export default __webpack_public_path__ + "static/icon-14-3-ff1d4f6706c15a1036c6c6171c87fa8e.png";